/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:01:07
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-20 17:38:53
 */
import req from "@/utils/request";
export const tree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const selectPage = (params) => req.post("/site-service/m/scoringCriteria/selectPage", params);
export const createNumber = (params) => req.post("/site-service/m/scoringCriteria/create", params);
export const createUpdate = (params) => req.post("/site-service/m/scoringCriteria/update", params);
export const deleteOnes = (params) => req.post("/site-service/m/scoringCriteria/delete", params);
export const up = (params) => req.post("/site-service/m/scoringCriteria/up", params);
export const down = (params) => req.post("/site-service/m/scoringCriteria/down", params);
export const notAdoptListPage = (params) => req.post("/site-service/m/push/notAdoptListPage", params);
export const noAdoption = (params) => req.post("/site-service/m/push/noAdoption", params);
export const details = (params) => req.post("/site-service/m/push/details", params);
export const detailsSelectPage = (params) => req.post("/site-service/m/scoringCriteria/selectPage", params);
export const originalAdoption = (params) => req.post("/site-service/m/push/originalAdoption", params);
export const acceptListPage = (params) => req.post("/site-service/m/push/acceptListPage", params);
export const pushScoringList = (params) => req.post("/site-service/m/adoptNumber/pushScoringList", params);
export const updateScoring = (params) => req.post("/site-service/m/adoptNumber/updateScoring", params);
export const adoptRemove = (params) => req.post("/site-service/m/push/adoptRemove", params);
export const updateScoringCriteria = (params) => req.post("/site-service/m/push/updateScoringCriteria", params);
